// @todo: refactor!!!
const listNavItens = [];

function getMenuHeight() {
  const menuElement = document.querySelector('.main-menu');
  return menuElement ? menuElement.clientHeight : 0;
}

function getOffsetTop(attribute) {
  const target = document.querySelector(attribute);
  return target ? target.offsetTop : undefined;
}

function tagItem(link) {
  listNavItens.forEach(function (item) {
    item.getAttribute('data-link') === link
      ? item.classList.add('selected')
      : item.classList.remove('selected');
  });
}

function scrollScreen() {
  const currentPos =
    window.scrollY + getMenuHeight() * 1.3 + window.innerHeight / 3.8;
  let selectedDataLink = {
    item: undefined,
    diff: Number.POSITIVE_INFINITY,
  };

  const userScrolledToBottom =
    window.innerHeight / 1.2 + window.scrollY > document.body.offsetHeight;
  if (userScrolledToBottom) {
    const lastItem = listNavItens[1];
    if (!lastItem || !lastItem.getAttribute('data-link')) return;

    const lastDataLink = lastItem.getAttribute('data-link');
    tagItem(lastDataLink);
    return;
  }

  for (let index in listNavItens) {
    const dataLink = listNavItens[Number(index)].getAttribute('data-link');
    const posDataLink = getOffsetTop(dataLink);

    if (getOffsetTop(dataLink) == 0 && dataLink !== '#overview') {
      continue;
    }

    const diffPosDataLinkForCurrent = Math.abs(posDataLink - currentPos);
    if (!posDataLink || diffPosDataLinkForCurrent > selectedDataLink.diff) {
      continue;
    }

    selectedDataLink = {
      item: dataLink,
      diff: diffPosDataLinkForCurrent,
    };
  }
  tagItem(selectedDataLink.item);
}

export function dangerouslyShowMenu() {
  if (document.querySelector('body').classList.contains('open-menu')) {
    document.querySelector('body').classList.remove('open-menu');
  } else {
    document.querySelector('body').classList.add('open-menu');
  }
}

export function moveSector(e) {
  if (window.innerWidth <= 960) {
    window.scrollTo({
      top: getOffsetTop(e.target.getAttribute('data-link')),
      behavior: 'smooth',
    });

    dangerouslyShowMenu();
  } else if (window.location.pathname === '/') {
    window.scrollTo({
      top: getOffsetTop(e.target.getAttribute('data-link')) - getMenuHeight(),
      behavior: 'smooth',
    });
  } else {
    window.scrollTo({
      top:
        getOffsetTop(e.target.getAttribute('data-link')) -
        getMenuHeight() -
        window.innerHeight / 10,
      behavior: 'smooth',
    });
  }
}

export function dangerouslyToggleTerms({ toHide = [], toShow = '' }) {
  const mobile = window.innerWidth <= 960 ? '-mobile' : '';

  toHide.map(div => {
    document.getElementById(div).style.display = 'none';
    document
      .getElementById(div + mobile + '-menu')
      .classList.remove('selected');
    document.getElementById(div + mobile + '-index').style.display = 'none';
  });

  document.getElementById(toShow).style.display = 'block';
  document.getElementById(toShow + mobile + '-menu').classList.add('selected');
  document.getElementById(toShow + mobile + '-index').style.display = 'block';

  listNavItens.sort(function (a, b) {
    return (
      getOffsetTop(b.getAttribute('data-link')) -
      getOffsetTop(a.getAttribute('data-link'))
    );
  });

  dangerouslyShowMenu();
}

export function dangerouslyScrollWatcher() {
  document.querySelectorAll('.nav-item').forEach(function (item) {
    listNavItens.push(item);
    item.addEventListener('click', moveSector);
  });

  listNavItens.sort(function (a, b) {
    return (
      getOffsetTop(b.getAttribute('data-link')) -
      getOffsetTop(a.getAttribute('data-link'))
    );
  });

  scrollScreen();
}

window.addEventListener('scroll', scrollScreen);
window.addEventListener('resize', scrollScreen);
